(function () {
  // Robust helper to find the nearest card container
  function closestCard(el) {
    return el.closest('.card, .card-wrapper, .quick-add, .product-card, .contains-card, li');
  }

  // Money formatting helper (Shopify provides formatMoney in most Dawn builds)
  function formatMoney(cents) {
    try {
      return Shopify.formatMoney(cents, (window.theme && window.theme.moneyFormat) || '${{amount}}');
    } catch (e) {
      // Fallback: naive formatting in shop currency
      const value = (Number(cents || 0) / 100).toFixed(2);
      return value;
    }
  }

  // Given a card node, read its embedded variants JSON
  function getVariants(card) {
    const rich = card.querySelector('.card-variants-rich-json');
    if (!rich) return [];
    try {
      return JSON.parse(rich.textContent.trim());
    } catch (e) {
      return [];
    }
  }

  // Update the "Starting from" price inside a given card
  function updateStartingFrom(card, cents) {
    const priceEl = card.querySelector('[data-starting-price]');
    if (!priceEl) return;
    priceEl.textContent = formatMoney(cents);
  }

  // Resolve currently selected options within the card (for fallback paths)
  function readSelections(card) {
    // Radios
    const radiosGroups = Array.from(card.querySelectorAll('[name^="options["]'))
      .filter(el => el.type === 'radio')
      .reduce((acc, input) => {
        if (input.checked) {
          const name = input.name;
          (acc[name] = acc[name] || []).push(input.value);
        }
        return acc;
      }, {});
    const radioSelections = Object.values(radiosGroups).flat();

    // Dropdowns
    const selects = Array.from(card.querySelectorAll('select[name^="options["]'))
      .map(sel => sel.value)
      .filter(Boolean);

    // Merge both in option order; Dawn keeps order stable
    return [...radioSelections, ...selects];
  }

  // Find a variant by options array (["Small","Blue"] etc.)
  function findVariantByOptions(variants, selections) {
    if (!variants || !variants.length || !selections || !selections.length) return null;
    return variants.find(v => {
      if (!v.options || v.options.length !== selections.length) return false;
      for (let i = 0; i < selections.length; i++) {
        if (String(v.options[i]) !== String(selections[i])) return false;
      }
      return true;
    });
  }

  // Handle Dawn's custom "variant:change" from product-variant-picker
  document.addEventListener('variant:change', function (evt) {
    const target = evt.target;
    const card = closestCard(target);
    if (!card) return;

    const variant = evt.detail && evt.detail.variant;
    if (!variant) return;

    // Only act if card actually has a starting-from block
    if (!card.querySelector('[data-starting-from]')) return;

    updateStartingFrom(card, variant.price);
  });

  // Fallback: listen to option changes within cards (inline quick-add)
  document.addEventListener('change', function (evt) {
    const el = evt.target;
    if (!el.matches('select[name^="options["], input[name^="options["]')) return;

    const card = closestCard(el);
    if (!card || !card.querySelector('[data-starting-from]')) return;

    const variants = getVariants(card);
    if (!variants.length) return;

    const selections = readSelections(card);
    const variant = findVariantByOptions(variants, selections) || null;

    if (variant) updateStartingFrom(card, variant.price);
  });

  // Optional: when quick-add modal injects content dynamically, you can observe new nodes:
  // (kept tiny; uncomment if needed)
  /*
  const obs = new MutationObserver(muts => {
    for (const m of muts) {
      m.addedNodes && m.addedNodes.forEach(node => {
        if (!(node instanceof Element)) return;
        // If the modal injects a product form with a picker already selected,
        // trigger a synthetic update so the card shows the right price.
        if (node.querySelector && node.querySelector('[data-starting-from]')) {
          // No-op here; relying on variant:change emitted by Dawn when it renders.
        }
      });
    }
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
  */
})();
